import { ArticleEntity } from 'src/modules/articles';

export enum ArticlesDetailsActions {
  FetchDetailsBegin = 'ARTICLES/DETAILS/FETCH/BEGIN',
  FetchDetailsSuccess = 'ARTICLES/DETAILS/FETCH/SUCCESS',
  FetchDetailsError = 'ARTICLES/DETAILS/FETCH/ERROR',
  FetchRelatedArticlesBegin = 'ARTICLES/DETAILS/RELATED_ARTICLES/FETCH/BEGIN',
  FetchRelatedArticlesSuccess = 'ARTICLES/DETAILS/RELATED_ARTICLES/FETCH/SUCCESS',
  FetchRelatedArticlesError = 'ARTICLES/DETAILS/RELATED_ARTICLES/FETCH/ERROR',
}

export interface ArticlesDetailsStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  relatedArticlesIsLoading: boolean;
  relatedArticlesIsLoaded: boolean;
  relatedArticlesError: any;
  article: ArticleEntity;
  relatedArticles: ArticleEntity[];
}
